/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-return-await */
import React, { useEffect, useState, useRef } from 'react';
import { Form } from '@unform/web';
import axios from 'axios';
import { FiFilter } from 'react-icons/fi';
import Swal from 'sweetalert2';
import {
  FaChevronLeft,
  FaChevronRight,
  FaEllipsisH,
  FaEdit,
  FaInfo,
  FaTractor,
  FaRedoAlt,
} from 'react-icons/fa';
import Pagination from 'react-paginate';
import {
  Button,
  Card,
  Col,
  Row,
  Table,
  UncontrolledCollapse,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  UncontrolledDropdown,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Label,
} from 'reactstrap';
import { toast } from 'react-toastify';
import { Input, ReactSelectAsync, Select } from '../../components/unform/index';
import api from '../../services/api';
import { Translator } from '../../components/i18n';
import { useAuth } from '../../contexts/auth';

const swalWithBootstrapButtons = Swal.mixin({
  customClass: {
    confirmButton: 'ml-3 btn btn-success',
    cancelButton: 'btn btn-danger',
  },
  buttonsStyling: false,
});

function Consultores() {
  const { user } = useAuth();

  const obrigatorio = Translator({
    path: 'obrigatorio',
  });
  const erroBuscaDados = Translator({
    path: 'erroBuscaDados',
  });
  const dadosSalvosSucesso = Translator({
    path: 'dadosSalvosSucesso',
  });
  const erroSalvarDados = Translator({
    path: 'erroSalvarDados',
  });
  const erro = Translator({
    path: 'erro',
  });
  const temcerteza = Translator({
    path: 'temcerteza',
  });
  const operacaoNaorevertida = Translator({
    path: 'operacaoNaorevertida',
  });
  const sim = Translator({
    path: 'sim',
  });
  const nao = Translator({
    path: 'nao',
  });
  const sucesso = Translator({
    path: 'sucesso',
  });
  const formRef = useRef();
  const formRefEdit = useRef();
  const formRefVinculo = useRef();

  const [consultores, setProdutores] = useState([]);
  const [selectedConsultor, setSelectedConsultor] = useState(null);
  const [filtro, setFiltro] = useState({});
  const [selectedUser, setSelectedUser] = useState(null);

  const [vinculoFazendas, setVinculoFazendas] = useState([]);

  const [modal, setModal] = useState(false);
  const [modalEdit, setModaledit] = useState(false);
  const [modalInfos, setModalInfos] = useState(false);
  const [modalVinculo, setModalVinculo] = useState(false);
  const [modalVinculoCad, setModalVinculoCad] = useState(false);

  const toggle = () => setModal(!modal);
  const toggleEdit = () => setModaledit(!modalEdit);
  const toggleInfos = () => setModalInfos(!modalInfos);
  const toggleVinculo = () => setModalVinculo(!modalVinculo);
  const toggleModalVinculo = () => setModalVinculoCad(!modalVinculoCad);

  async function filtrarConsultaFazendaAsync(inputValue) {
    const { data } = await api.get(`/fazenda-async?nome=${inputValue}`);

    return data.map((e) => ({ value: e.id, label: e.nome }));
  }

  let selectOptions;
  const optionsFazendas = async (inputValue) =>
    await new Promise((resolve) => {
      clearTimeout(selectOptions);

      selectOptions = setTimeout(() => {
        resolve(filtrarConsultaFazendaAsync(inputValue));
      }, 500);
    });

  let timeoutConsulta;
  function filtrarConsulta(e, value) {
    setFiltro({ ...filtro, [value]: e, page: 1 });
  }

  const debounceConsulta = async (body, value) =>
    new Promise((resolve) => {
      clearTimeout(timeoutConsulta);

      timeoutConsulta = setTimeout(() => {
        resolve(filtrarConsulta(body, value));
      }, 500);
    });

  async function getConsultores() {
    Swal.fire({
      allowOutsideClick: false,
      showConfirmButton: false,
      didOpen: () => {
        Swal.showLoading();
      },
    });

    const params = Object.keys(filtro)
      .map((e) => {
        if (e === 'page') {
          if (Number.isNaN(filtro[e])) {
            return `${e}=${1}`;
          }
        }
        return `${e}=${filtro[e]}`;
      })
      .join('&');

    const { data } = await api.get(`/consultores?${params}`);

    setProdutores(data);
    window.scrollTo(0, 0);

    Swal.close();
  }

  useEffect(() => {
    getConsultores();
  }, [filtro]);

  const handleSubmitConsultor = async (data) => {
    const errors = {};

    Object.keys(data).forEach((f) => {
      if (!data[f] && f !== 'complemento' && f !== 'cep') {
        errors[f] = obrigatorio;
      }
    });

    formRef.current.setErrors(errors);

    if (!Object.keys(errors).length) {
      Swal.fire({
        allowOutsideClick: false,
        showConfirmButton: false,
        didOpen: () => {
          Swal.showLoading();
        },
      });
      try {
        data.perfil = 3;

        await api.post('/parceiro', data);

        toast.success(dadosSalvosSucesso);
        toggle();
        getConsultores();
        Swal.close();
      } catch (err) {
        toast.error(err?.response?.data?.error || erroSalvarDados);
        Swal.close();
      }
    }
  };

  const consultarCep = async (data) => {
    if (data) {
      Swal.fire({
        allowOutsideClick: false,
        showConfirmButton: false,
        didOpen: () => {
          Swal.showLoading();
        },
      });
      try {
        const { data: resultCep } = await axios.get(
          `https://brasilapi.com.br/api/cep/v2/${data}`
        );
        if (resultCep) {
          formRef.current.setFieldValue('logradouro', resultCep?.street);
          formRef.current.setFieldValue('estado', resultCep?.state);
          formRef.current.setFieldValue('cidade', resultCep?.city);
          formRef.current.setFieldValue('bairro', resultCep?.neighborhood);
        }
        Swal.close();
      } catch (err) {
        formRef.current.setFieldValue('logradouro', '');
        formRef.current.setFieldValue('estado', '');
        formRef.current.setFieldValue('cidade', '');
        formRef.current.setFieldValue('bairro', '');
        toast.warning('CEP não encontrado!');
        Swal.close();
      }
    }
  };

  const handleEditConsultor = async (data) => {
    const errors = {};

    Object.keys(data).forEach((f) => {
      if (!data[f] && f !== 'complemento' && f !== 'cep') {
        errors[f] = obrigatorio;
      }
    });

    formRefEdit.current.setErrors(errors);

    if (!Object.keys(errors).length) {
      Swal.fire({
        allowOutsideClick: false,
        showConfirmButton: false,
        didOpen: () => {
          Swal.showLoading();
        },
      });
      try {
        await api.put(`/consultor/${selectedConsultor?.usuario?.id}`, data);
        toast.success(dadosSalvosSucesso);
        setSelectedConsultor(null);
        getConsultores();
        toggleEdit();
        Swal.close();
      } catch (err) {
        toast.error(err?.response?.data?.error || erroSalvarDados);
        Swal.close();
      }
    }
  };

  const getInfosConsultores = async (id, tipo) => {
    Swal.fire({
      allowOutsideClick: false,
      showConfirmButton: false,
      didOpen: () => {
        Swal.showLoading();
      },
    });
    try {
      const { data } = await api.get(`/consultor/${id}`);

      setSelectedConsultor(data);
      if (tipo === 'I') {
        toggleInfos();
      } else if (tipo === 'E') {
        toggleEdit();
      }
      Swal.close();
    } catch (err) {
      toast.error(erroBuscaDados);
      Swal.close();
    }
  };

  const getVinculos = async (id) => {
    Swal.fire({
      allowOutsideClick: false,
      showConfirmButton: false,
      didOpen: () => {
        Swal.showLoading();
      },
    });
    try {
      const { data } = await api.get(`/get-vinculos/${id}`);

      setSelectedUser(id);
      setVinculoFazendas(data);
      toggleVinculo();
      Swal.close();
    } catch (err) {
      toast.error(erroBuscaDados);
      Swal.close();
    }
  };

  const handleExcluirVinculo = async (id, idUser) => {
    Swal.fire({
      allowOutsideClick: false,
      showConfirmButton: false,
      didOpen: () => {
        Swal.showLoading();
      },
    });
    try {
      await api.delete(`/vinculo/${id}`);

      const { data } = await api.get(`/get-vinculos/${idUser}`);

      setVinculoFazendas(data);
      Swal.close();
    } catch (err) {
      toast.error(erro);
      Swal.close();
    }
  };

  const handleAddVinculos = async (body) => {
    Swal.fire({
      allowOutsideClick: false,
      showConfirmButton: false,
      didOpen: () => {
        Swal.showLoading();
      },
    });
    try {
      const { data } = await api.post(
        `/vinculos-cons-operacional/${selectedUser}`,
        body
      );
      setVinculoFazendas(data);
      toggleModalVinculo();
      Swal.close();
    } catch (err) {
      toast.error(erro);
      Swal.close();
    }
  };

  const handleResetPassword = async (idUser) => {
    swalWithBootstrapButtons
      .fire({
        title: temcerteza,
        text: operacaoNaorevertida,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: sim,
        cancelButtonText: nao,
        reverseButtons: true,
      })
      .then(async (result) => {
        if (result.value) {
          Swal.fire({
            allowOutsideClick: false,
            showConfirmButton: false,
            didOpen: () => {
              Swal.showLoading();
            },
          });
          try {
            await api.put(`/resetar/senha/${idUser}`);
            toast.success(sucesso);
          } catch (er) {
            toast.error(erro);
          }
          Swal.close();
        }
      });
  };

  return (
    <>
      <Row>
        <Col>
          <h4 className="mb-3">
            <Translator path="consultores.label" />
          </h4>
        </Col>
      </Row>
      <Card>
        <div className="p-3 justify-content-between d-flex align-items-center">
          <Col lg={6}>
            <h6 className="txt-muted">
              <Translator path="excecoes.totalregistros" /> {consultores.total}
            </h6>
          </Col>
          <Col>
            <Button
              color="muted"
              id="toggler"
              className="d-flex align-items-center"
            >
              <FiFilter size={20} />
              &nbsp;&nbsp;
              <Translator path="consultores.filtro" />
            </Button>
          </Col>
          <div className="d-flex justify-content-center">
            <Button
              onClick={() => toggle()}
              type="button"
              className="btn btn-primary ml-3"
            >
              <Translator path="consultores.novo" />
            </Button>
          </div>
          <div className="d-flex justify-content-center" />
        </div>
        <div className="filter-collapse px-3 ">
          <UncontrolledCollapse toggler="#toggler" className="pb-3">
            <Row>
              <Col lg={3}>
                <Label>
                  <Translator path="consultores.filtro.name" />
                </Label>
                <input
                  onChange={(e) => debounceConsulta(e.target.value, 'nome')}
                  className="form-control"
                />
              </Col>
            </Row>
          </UncontrolledCollapse>
        </div>

        <Table responsive>
          <thead>
            <tr>
              <th>
                <Translator path="consultores.nome" />
              </th>
              <th>
                <Translator path="consultores.email" />
              </th>
              <th className="text-center">
                <Translator path="consultores.status" />
              </th>
              <th className="text-center">
                <Translator path="consultores.acao" />
              </th>
            </tr>
          </thead>
          <tbody>
            {consultores?.consultores?.length ? (
              consultores.consultores?.map((c) => (
                <tr key={c?.id}>
                  <td>{c?.nome}</td>
                  <td>{c?.email}</td>
                  <td className="text-center">{c?.status}</td>
                  <td className="text-center">
                    <UncontrolledDropdown
                      size="xs"
                      style={{ position: 'absolute' }}
                    >
                      <DropdownToggle color="link link-gray" size="xs">
                        <FaEllipsisH size="1.3em" color="#43b02a" />
                      </DropdownToggle>
                      <DropdownMenu right>
                        <DropdownItem
                          onClick={() => getInfosConsultores(c?.id, 'I')}
                          size="xs"
                        >
                          <FaInfo className="mr-1" size={18} />
                          <Translator path="consultores.acao.infosconsultor.label" />
                        </DropdownItem>
                        <DropdownItem
                          onClick={() => getVinculos(c?.id)}
                          size="xs"
                        >
                          <FaTractor className="mr-1" size={18} />
                          <Translator path="consultores.vincularfazenda.novolink.label" />
                        </DropdownItem>
                        <hr />
                        <DropdownItem
                          onClick={() => getInfosConsultores(c?.id, 'E')}
                          size="xs"
                        >
                          <FaEdit className="mr-1" size={18} />
                          <Translator path="consultores.acao.editarconsultor" />
                        </DropdownItem>
                        <hr />
                        <DropdownItem
                          onClick={() => handleResetPassword(c?.id)}
                          size="xs"
                        >
                          <FaRedoAlt className="mr-1" size={18} />
                          <Translator path="consultores.acao.resetarsenha" />
                        </DropdownItem>
                      </DropdownMenu>
                    </UncontrolledDropdown>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td>
                  <Translator path="excecoes.semregistros" />
                </td>
              </tr>
            )}
          </tbody>
        </Table>
        <Pagination
          nextLabel={<FaChevronRight />}
          previousLabel={<FaChevronLeft />}
          pageCount={consultores.pages || 1}
          onPageChange={({ selected }) =>
            setFiltro({ ...filtro, page: selected + 1 })
          }
          initialPage={0}
          containerClassName="pagination justify-end mr-1"
          activeClassName="active"
        />
      </Card>

      <Modal isOpen={modal} toggle={toggle} size="lg">
        <ModalHeader toggle={toggle}>
          <Translator path="consultores.novo" />
        </ModalHeader>
        <Form ref={formRef} onSubmit={(data) => handleSubmitConsultor(data)}>
          <ModalBody>
            <Row>
              <Col lg={8}>
                <Input
                  name="nome"
                  label={<Translator path="consultores.nome" />}
                  className="form-control"
                  type="text"
                />
              </Col>
              <Col lg={4}>
                <Select
                  label={
                    <Translator path="fazenda.novafazenda.tipodocumento" />
                  }
                  className="form-control"
                  name="tipo_documento"
                  data={[
                    {
                      label: Translator({
                        path: 'fazenda.upload.selecione',
                      }),
                      value: '',
                    },
                    {
                      label: 'RG',
                      value: 'RG',
                    },
                    {
                      label: 'CNH',
                      value: 'CNH',
                    },
                    {
                      label: 'RNM',
                      value: 'RNM',
                    },
                    {
                      label: Translator({
                        path: 'outros',
                      }),
                      value: 'Outros',
                    },
                  ]}
                />
              </Col>
            </Row>
            <Row>
              <Col lg={4}>
                <Input
                  name="documento"
                  label={
                    <Translator path="consultores.acao.infosconsultor.documento" />
                  }
                  className="form-control"
                  type="text"
                />
              </Col>
              <Col lg={4}>
                <Input
                  name="email"
                  label={
                    <Translator path="consultores.acao.infosconsultor.email" />
                  }
                  className="form-control"
                  type="email"
                />
              </Col>
              <Col lg={4}>
                <Input
                  name="telefone"
                  label={
                    <Translator path="consultores.acao.infosconsultor.telefone" />
                  }
                  className="form-control"
                  type="text"
                />
              </Col>
            </Row>
            <Row>
              <Col lg={6}>
                <Select
                  label={
                    <Translator path="consultores.editarconsultor.temporario" />
                  }
                  className="form-control"
                  name="temporario"
                  data={[
                    {
                      label: Translator({
                        path: 'nao',
                      }),
                      value: false,
                    },
                    {
                      label: Translator({
                        path: 'sim',
                      }),
                      value: true,
                    },
                  ]}
                />
              </Col>
              <Col lg={6}>
                <Input
                  name="dias"
                  label={<Translator path="consultores.editarconsultor.dias" />}
                  className="form-control"
                  type="number"
                  defaultValue={0}
                />
              </Col>
            </Row>
            <Row>
              <Col lg={3}>
                <Input
                  name="cep"
                  label={<Translator path="consultores.editarconsultor.cep" />}
                  className="form-control"
                  onBlur={(e) => {
                    consultarCep(e.target.value);
                  }}
                  type="text"
                />
              </Col>
              <Col lg={6}>
                <Input
                  name="logradouro"
                  label={
                    <Translator path="consultores.editarconsultor.logradouro" />
                  }
                  className="form-control"
                  type="text"
                />
              </Col>
              <Col lg={3}>
                <Input
                  name="numero"
                  label={
                    <Translator path="consultores.editarconsultor.numero" />
                  }
                  className="form-control"
                  type="number"
                />
              </Col>
            </Row>
            <Row>
              <Col lg={4}>
                <Input
                  name="bairro"
                  label={
                    <Translator path="consultores.editarconsultor.bairro" />
                  }
                  className="form-control"
                  type="text"
                />
              </Col>
              <Col lg={4}>
                <Input
                  name="estado"
                  label={
                    <Translator path="consultores.editarconsultor.estadao" />
                  }
                  className="form-control"
                  type="text"
                />
              </Col>
              <Col lg={4}>
                <Input
                  name="cidade"
                  label={
                    <Translator path="consultores.editarconsultor.cidade" />
                  }
                  className="form-control"
                  type="text"
                />
              </Col>
            </Row>
            <Row>
              <Col lg={12}>
                <Input
                  name="complemento"
                  label={
                    <Translator path="consultores.editarconsultor.complemento" />
                  }
                  className="form-control"
                  type="text"
                />
              </Col>
            </Row>
            <Row>
              <Col lg={12}>
                <ReactSelectAsync
                  label={<Translator path="fazenda.label" />}
                  name="fazenda"
                  isClearable
                  isMulti
                  loadOptions={optionsFazendas}
                />
              </Col>
            </Row>
          </ModalBody>
          <ModalFooter>
            <Button color="success" type="submit">
              <Translator path="botao.salvar" />
            </Button>
          </ModalFooter>
        </Form>
      </Modal>

      <Modal isOpen={modalEdit} toggle={toggleEdit} size="lg">
        <ModalHeader toggle={toggleEdit}>
          <Translator path="consultores.editarconsultor.label" />
        </ModalHeader>
        <Form ref={formRefEdit} onSubmit={(data) => handleEditConsultor(data)}>
          <ModalBody>
            <Row>
              <Col lg={6}>
                <Input
                  name="nome"
                  label={<Translator path="consultores.editarconsultor.nome" />}
                  className="form-control"
                  type="text"
                  defaultValue={selectedConsultor?.usuario?.nome}
                />
              </Col>
              {user?.perfil && (
                <Col lg={6}>
                  <Input
                    name="email"
                    label={
                      <Translator path="consultores.acao.infosconsultor.email" />
                    }
                    className="form-control"
                    type="text"
                    defaultValue={selectedConsultor?.usuario?.email}
                  />
                </Col>
              )}
            </Row>
            <Row>
              <Col lg={4}>
                <Select
                  label={
                    <Translator path="consultores.editarconsultor.tipodocumento" />
                  }
                  className="form-control"
                  name="tipo_documento"
                  defaultValue={selectedConsultor?.parceiro?.tipo_documento}
                  data={[
                    {
                      label: Translator({
                        path: 'fazenda.upload.selecione',
                      }),
                      value: '',
                    },
                    {
                      id: 'RG',
                      label: 'RG',
                      value: 'RG',
                    },
                    {
                      id: 'CNH',
                      label: 'CNH',
                      value: 'CNH',
                    },
                    {
                      id: 'RNM',
                      label: 'RNM',
                      value: 'RNM',
                    },
                    {
                      id: 'Outros',
                      label: Translator({
                        path: 'outros',
                      }),
                      value: 'Outros',
                    },
                  ]}
                />
              </Col>
              <Col lg={4}>
                <Input
                  name="documento"
                  label={
                    <Translator path="consultores.editarconsultor.documento" />
                  }
                  className="form-control"
                  type="text"
                  defaultValue={selectedConsultor?.parceiro?.documento}
                />
              </Col>
              <Col lg={4}>
                <Select
                  label={
                    <Translator path="consultores.editarconsultor.status" />
                  }
                  className="form-control"
                  name="status"
                  defaultValue={selectedConsultor?.parceiro?.status}
                  data={[
                    {
                      id: 'A',
                      label: Translator({
                        path: 'fazenda.ativetalhoes.ativo',
                      }),
                      value: 'A',
                    },
                    {
                      id: 'I',
                      label: Translator({
                        path: 'fazenda.ativetalhoes.inativo',
                      }),
                      value: 'I',
                    },
                  ]}
                />
              </Col>
              <Col lg={4}>
                <Input
                  name="telefone"
                  label={
                    <Translator path="consultores.editarconsultor.telefone" />
                  }
                  className="form-control"
                  type="text"
                  defaultValue={selectedConsultor?.parceiro?.telefone}
                />
              </Col>
              <Col lg={4}>
                <Select
                  label={
                    <Translator path="consultores.editarconsultor.temporario" />
                  }
                  className="form-control"
                  name="temporario"
                  defaultValue={selectedConsultor?.usuario?.temporario}
                  data={[
                    {
                      id: false,
                      label: Translator({
                        path: 'nao',
                      }),
                      value: false,
                    },
                    {
                      id: true,
                      label: Translator({
                        path: 'sim',
                      }),
                      value: true,
                    },
                  ]}
                />
              </Col>
              <Col lg={4}>
                <Input
                  name="dias"
                  label={<Translator path="operacional.editarconsultor.dias" />}
                  className="form-control"
                  type="number"
                  defaultValue={selectedConsultor?.usuario?.dias}
                />
              </Col>
            </Row>
            <Row>
              <Col lg={3}>
                <Input
                  name="cep"
                  label={<Translator path="operacional.editarconsultor.cep" />}
                  className="form-control"
                  defaultValue={selectedConsultor?.parceiro?.cep}
                  onBlur={(e) => {
                    consultarCep(e.target.value);
                  }}
                  type="text"
                />
              </Col>
              <Col lg={6}>
                <Input
                  name="logradouro"
                  label={
                    <Translator path="operacional.editarconsultor.logradouro" />
                  }
                  className="form-control"
                  defaultValue={selectedConsultor?.parceiro?.logradouro}
                  type="text"
                />
              </Col>
              <Col lg={3}>
                <Input
                  name="numero"
                  label={
                    <Translator path="operacional.editarconsultor.numero" />
                  }
                  className="form-control"
                  defaultValue={selectedConsultor?.parceiro?.numero}
                  type="number"
                />
              </Col>
            </Row>
            <Row>
              <Col lg={4}>
                <Input
                  name="bairro"
                  label={
                    <Translator path="operacional.editarconsultor.bairro" />
                  }
                  className="form-control"
                  defaultValue={selectedConsultor?.parceiro?.bairro}
                  type="text"
                />
              </Col>
              <Col lg={4}>
                <Input
                  name="estado"
                  label={
                    <Translator path="operacional.editarconsultor.estadao" />
                  }
                  className="form-control"
                  defaultValue={selectedConsultor?.parceiro?.estado}
                  type="text"
                />
              </Col>
              <Col lg={4}>
                <Input
                  name="cidade"
                  label={
                    <Translator path="operacional.editarconsultor.cidade" />
                  }
                  className="form-control"
                  defaultValue={selectedConsultor?.parceiro?.cidade}
                  type="text"
                />
              </Col>
            </Row>
            <Row>
              <Col lg={12}>
                <Input
                  name="complemento"
                  label={
                    <Translator path="operacional.editarconsultor.complemento" />
                  }
                  className="form-control"
                  defaultValue={selectedConsultor?.parceiro?.complemento}
                  type="text"
                />
              </Col>
            </Row>
          </ModalBody>
          <ModalFooter>
            <Button color="success" type="submit">
              <Translator path="botao.salvar" />
            </Button>
          </ModalFooter>
        </Form>
      </Modal>

      <Modal isOpen={modalInfos} toggle={toggleInfos} size="lg">
        <ModalHeader toggle={toggleInfos}>
          <Translator path="consultores.acao.infosconsultor.label" />
        </ModalHeader>
        <ModalBody>
          <Row>
            <Col lg={4}>
              <h6>
                <strong>
                  <Translator path="consultores.acao.infosconsultor.nome" />:
                </strong>{' '}
                {selectedConsultor?.parceiro?.nome}
              </h6>
            </Col>
            <Col lg={6}>
              <h6>
                <strong>
                  <Translator path="consultores.acao.infosconsultor.email" />:
                </strong>{' '}
                {selectedConsultor?.usuario?.email}
              </h6>
            </Col>
            <Col>
              <h6>
                <strong>
                  <Translator path="consultores.acao.infosconsultor.status" />:
                </strong>{' '}
                {selectedConsultor?.usuario?.status}
              </h6>
            </Col>
          </Row>
          <br />
          <Row>
            <Col lg={4}>
              <h6>
                <strong>
                  <Translator path="consultores.acao.infosconsultor.telefone" />
                  :
                </strong>{' '}
                {selectedConsultor?.parceiro?.telefone}
              </h6>
            </Col>
            <Col lg={6}>
              <h6>
                <strong>
                  <Translator path="consultores.acao.infosconsultor.documento" />
                  :
                </strong>{' '}
                {selectedConsultor?.parceiro?.documento}
              </h6>
            </Col>
            <Col lg={2}>
              <h6>
                <strong>
                  <Translator path="consultores.acao.infosconsultor.tipo" />:
                </strong>{' '}
                {selectedConsultor?.parceiro?.tipo_documento}
              </h6>
            </Col>
          </Row>
          <hr />
          <Row>
            <Col lg={4}>
              <h6>
                <strong>
                  <Translator path="consultores.acao.infosconsultor.cep" />:
                </strong>{' '}
                {selectedConsultor?.parceiro?.cep}
              </h6>
            </Col>
            <Col lg={6}>
              <h6>
                <strong>
                  <Translator path="consultores.acao.infosconsultor.cidade" />:
                </strong>{' '}
                {selectedConsultor?.parceiro?.cidade}
              </h6>
            </Col>
            <Col>
              <h6>
                <strong>
                  <Translator path="consultores.acao.infosconsultor.estado" />:
                </strong>{' '}
                {selectedConsultor?.parceiro?.estado}
              </h6>
            </Col>
          </Row>
          <br />
          <Row>
            <Col lg={10}>
              <h6>
                <strong>
                  <Translator path="consultores.acao.infosconsultor.logradouro" />
                  :
                </strong>{' '}
                {selectedConsultor?.parceiro?.logradouro}
              </h6>
            </Col>
            <Col lg={2}>
              <h6>
                <strong>
                  <Translator path="consultores.acao.infosconsultor.numero" />:
                </strong>{' '}
                {selectedConsultor?.parceiro?.numero}
              </h6>
            </Col>
          </Row>
        </ModalBody>
      </Modal>

      <Modal isOpen={modalVinculo} toggle={toggleVinculo} size="lg">
        <ModalHeader toggle={toggleVinculo}>
          <Translator path="consultores.vincularfazenda.novolink.label" />
        </ModalHeader>
        <div className="d-flex justify-content-end">
          <Button
            onClick={() => toggleModalVinculo()}
            type="button"
            className="btn btn-primary mr-3 mt-2"
          >
            <Translator path="consultores.vincularfazenda.novolink" />
          </Button>
        </div>
        <ModalBody>
          <Row>
            <Table responsive>
              <thead>
                <tr>
                  <th>
                    <Translator path="consultores.vincularfazenda.novolink.fazenda" />
                  </th>
                  <th>
                    <Translator path="consultores.vincularfazenda.responsavel" />
                  </th>
                  <th className="text-center">
                    <Translator path="consultores.vincularfazenda.acao" />
                  </th>
                </tr>
              </thead>
              <tbody>
                {vinculoFazendas?.length ? (
                  vinculoFazendas?.map((c) => (
                    <tr key={c?.id}>
                      <td>{c?.Fazenda?.nome}</td>
                      <td>{c?.Fazenda?.responsavel}</td>
                      <td className="text-center">
                        <UncontrolledDropdown size="xs">
                          <DropdownToggle color="link link-gray" size="xs">
                            <FaEllipsisH size="1.3em" color="#43b02a" />
                          </DropdownToggle>
                          <DropdownMenu right>
                            <DropdownItem
                              onClick={() =>
                                handleExcluirVinculo(c?.id, c?.id_usuario)
                              }
                              size="xs"
                            >
                              <FaEdit className="mr-1" size={18} />
                              <Translator path="plugfield.acao.delete" />
                            </DropdownItem>
                          </DropdownMenu>
                        </UncontrolledDropdown>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td>
                      <Translator path="excecoes.semregistros" />
                    </td>
                  </tr>
                )}
              </tbody>
            </Table>
          </Row>
        </ModalBody>
        <ModalFooter>
          <Button color="success" type="button" onClick={() => toggleVinculo()}>
            Ok
          </Button>
        </ModalFooter>
      </Modal>

      <Modal isOpen={modalVinculoCad} toggle={toggleModalVinculo} size="lg">
        <ModalHeader toggle={toggleModalVinculo}>
          <Translator path="consultores.vincularfazenda.novolink.label" />
        </ModalHeader>
        <Form ref={formRefVinculo} onSubmit={(data) => handleAddVinculos(data)}>
          <ModalBody>
            <Row>
              <Col lg={12}>
                <ReactSelectAsync
                  label={<Translator path="fazenda.label" />}
                  name="fazenda"
                  isClearable
                  isMulti
                  loadOptions={optionsFazendas}
                />
              </Col>
            </Row>
          </ModalBody>
          <ModalFooter>
            <Button color="success" type="submit">
              <Translator path="botao.salvar" />
            </Button>
          </ModalFooter>
        </Form>
      </Modal>
    </>
  );
}

export default Consultores;
